import { Stack, TextField} from "@mui/material"

export const FilterWork = ({ setFilterArray, copyArray }) => {

    const handleSubmit = (e) => {
        e.preventDefault();
        const filter = e.target.value.toUpperCase();

        const newFilterArray = copyArray.filter((row) => row.addressWork?.toUpperCase().includes(filter) || row.contact?.toUpperCase().includes(filter) || row.firstDate?.includes(filter));

        setFilterArray(newFilterArray)
    }

    return (
        <Stack component='form' flexDirection='row' justifyContent='space-between' width='100%' mb='1rem' >
            <TextField
                label="Filtrar por dirección, contacto o fecha de inicio"
                defaultValue=""
                size="small"
                name="filter"
                sx={{width:'100%'}}
                onChange={handleSubmit}
            />

        </Stack>
    )
}